import templateUrl from './teams-list.component.html'

export const TeamsListComponent = {
    templateUrl,
    controller: TeamsListController,
    controllerAs: "vm"
}

function TeamsListController($q, $uibModal, teamService, utilityService) {
    'ngInject'
    const vm = this;

    vm.$onInit = onInit;
    vm.onEdit = onEdit;
    vm.onDelete = onDelete;
    vm.teams;

    function onInit() {
        const teamsLoaded = teamService.retrieveTeams()
            .then(function (teams) {
                vm.teams = teams;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(teamsLoaded, "Initial load failed"));
    }

    function onEdit(team) {
        // The team edit model is slightly different from the list model.
        const model = team ? teamService.retrieveTeam(team.TeamID) : $q.when({
            TeamMembers: [],
            Roles: []
        });
        $uibModal.open({
            component: "apexEditTeamModal",
            resolve: {
                team: function () {
                    return model;
                }
            }
        }).result.then(function () {
            return teamService.retrieveTeams()
        }).then(function (teams) {
            vm.teams = teams;
        });
    }

    function onDelete(team) {
        if (!confirm("The team will be deleted. Continue?")) {
            return;
        }

        const teamDeleted = teamService.deleteTeam(team.TeamID);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(teamDeleted, "Delete failed"));
        teamDeleted.then(function () {
            vm.teams = vm.teams.filter(function (t) {
                return t.TeamID !== team.TeamID;
            })
        })
    }
}
